module.exports = __webpack_public_path__ + "assets/img/ZT8350-M.a9598075.png";